/** @jsx jsx */

/** @jsxFrag */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';


import LandingPageHome from './ChallengeLabsLandingPage/LandingPageHome';

const styles = {
  main: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

const CodingChallengesApp = () => (
  <>
    <SimpleCourseraMetatags />
    <main css={styles.main}>
      <LandingPageHome />
    </main>
  </>
);

export default CodingChallengesApp;
